import uxAnalyticsUtil from './uxAnalyticsUtil';

export const playbackStates = {
  playing: 'PLAYING',
  paused: 'PAUSED',
  stopped: 'STOPPED'
};

// let speechIntervalHack;

let speech = window.speechSynthesis;
let currentVoice;
var speechAvailable = false;

const getSpeechAvailable = () => speechAvailable;

const setLanguage = lang => {
  if (speech) {
    let availableVoices = speech.getVoices().filter(voice => {
      const voiceLang = voice.lang.substr(0, 2);
      return voiceLang === lang;
    });
    currentVoice = availableVoices[0];
    if (!currentVoice) {
      speechAvailable = false;
    } else {
      speechAvailable = true;
    }
  }
};

/**
 * Chunkify
 * Google Chrome Speech Synthesis Chunking Pattern
 * Fixes inconsistencies with speaking long texts in speechUtterance objects
 * Licensed under the MIT License
 *
 * Peter Woolley and Brett Zamir
 * Modified by Haaris for bug fixes
 */

const speechUtteranceChunker = function (
  utt,
  settings = {},
  onEnd,
  onBoundary
) {
  let newUtt;
  let txt =
    settings && settings.offset !== undefined
      ? utt.text.substring(settings.offset)
      : utt.text;
  // if (onBoundary !== undefined) {
  //   onBoundary(settings);
  // }
  if (utt.voice && utt.voice.voiceURI === 'native') {
    // Not part of the spec
    newUtt = utt;
    newUtt.text = txt;
    newUtt.addEventListener('end', function () {
      if (speechUtteranceChunker.cancel) {
        speechUtteranceChunker.cancel = false;
      }
      if (onEnd !== undefined) {
        onEnd();
      }
    });
  } else {
    let chunkLength = (settings && settings.chunkLength) || 160;
    let pattRegex = new RegExp(
      '^[\\s\\S]{' +
        Math.floor(chunkLength / 2) +
        ',' +
        chunkLength +
        '}[.!?,]{1}|^[\\s\\S]{1,' +
        chunkLength +
        '}$|^[\\s\\S]{1,' +
        chunkLength +
        '} '
    );
    let chunkArr = txt.match(pattRegex);

    if (
      chunkArr == null ||
      chunkArr[0] === undefined ||
      chunkArr[0].length <= 2
    ) {
      //call once all text has been spoken...
      if (onEnd !== undefined) {
        onEnd();
      }
      return;
    }
    let chunk = chunkArr[0];
    newUtt = new SpeechSynthesisUtterance(chunk);
    newUtt.lang = currentVoice.lang;
    newUtt.voice = currentVoice;
    newUtt.rate = 1;
    if (onBoundary) {
      newUtt.onboundary = ({charIndex, charLength, timeStamp}) => {
        // console.log('onboundaryinside', data, settings);
        onBoundary({
          charIndex: (settings.offset ?? 0) + charIndex,
          charLength,
          timeStamp
        });
      };
    }
    let x;
    for (x in utt) {
      if (utt.hasOwnProperty(x) && x !== 'text') {
        newUtt[x] = utt[x];
      }
    }
    newUtt.addEventListener('end', function () {
      if (speechUtteranceChunker.cancel) {
        speechUtteranceChunker.cancel = false;
        return;
      }
      settings.offset = settings.offset || 0;
      settings.offset += chunk.length;
      speechUtteranceChunker(utt, settings, onEnd, onBoundary);
    });
  }

  if (settings.modifier) {
    settings.modifier(newUtt);
  }
  //placing the speak invocation inside a callback fixes ordering and onend issues.
  setTimeout(function () {
    // console.log('speak', {text, ...newUtt});
    speech.speak(newUtt);
  }, 0);
};

const speak = ({words, onError, onBoundary, onEnd}) => {
  try {
    if (speechAvailable) {
      const utterance = new SpeechSynthesisUtterance();
      utterance.volume = 0.5;
      utterance.text = words;
      // utterance.onend = onEnd;
      // utterance.onerror = onError;
      // utterance.onboundary = onBoundary;
      utterance.lang = currentVoice.lang;
      utterance.voice = currentVoice;

      speechUtteranceChunker(
        utterance,
        {
          chunkLength: 160
        },
        function () {
          //some code to execute when done
          onEnd();
        },
        function ({charIndex, charLength, timeStamp}) {
          // TODO: highlight current word / position in text
          if (onBoundary) {
            onBoundary({charIndex, charLength, timeStamp});
          }
        }
      );
    }
  } catch (error) {
    console.log('failed', error);
    uxAnalyticsUtil.trackException({
      category: 'Reading',
      action: 'speak_speech',
      label: 'failed',
      nonInteraction: true
    });
  }
};

const pause = () => {
  try {
    speech.pause();
  } catch (error) {
    uxAnalyticsUtil.trackException({
      category: 'Reading',
      action: 'pause_speech',
      label: 'failed',
      nonInteraction: true
    });
  }
};

const resume = () => {
  try {
    speech.resume();
  } catch (error) {
    uxAnalyticsUtil.trackException({
      category: 'Reading',
      action: 'resume_speech',
      label: 'failed',
      nonInteraction: true
    });
  }
};

const cancel = stopAll => {
  try {
    speechUtteranceChunker.cancel = stopAll;
    speech.cancel();
  } catch (error) {
    uxAnalyticsUtil.trackException({
      category: 'Reading',
      action: 'cancel_speech',
      label: 'failed',
      nonInteraction: true
    });
  }
};

export default {
  speak,
  pause,
  resume,
  cancel,
  setLanguage,
  getSpeechAvailable
};
